export const LICENSED_THEME_NAME = "Times";
